import React from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { useLogStore } from '../store/useLogStore'
import Button from './ui/Button'

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // Log the error globally silently
    useLogStore.getState().addLog('error', 'Fatal React Error', `${error.message}\n\n${errorInfo.componentStack}`)
    console.error('Uncaught error:', error, errorInfo)
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
    // Options: window.location.reload() or just clear state
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-950 flex flex-col items-center justify-center p-6 pb-20">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mb-6">
            <AlertTriangle size={32} className="text-red-500" />
          </div>
          <h1 className="text-2xl font-black text-white text-center mb-2">Un problème est survenu</h1>
          <p className="text-gray-400 text-center text-sm mb-8 max-w-sm">
            L'application a rencontré une erreur inattendue. Mettez à jour ou relancez l'application. 
            Vos brouillons ont été sauvegardés.
          </p>
          
          <Button onClick={this.handleReset} size="lg" className="w-full max-w-xs flex items-center justify-center gap-2">
            <RefreshCw size={20} />
            Relancer l'application
          </Button>

          <details className="mt-8 text-left w-full max-w-md bg-gray-900 rounded-xl p-4 overflow-hidden border border-gray-800">
            <summary className="text-xs font-semibold text-gray-500 cursor-pointer outline-none select-none">
              Détails techniques
            </summary>
            <p className="text-[10px] text-red-400 font-mono mt-3 whitespace-pre-wrap break-words">
              {this.state.error?.toString()}
            </p>
          </details>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
